// extracted by mini-css-extract-plugin
export default {"list":"SearchFilterList_list__6yofN"};